import React, {
  ReactNode,
  MouseEvent
} from 'react';
import dompurify from 'dompurify';
import classNames from 'classnames';
import { ContainerClass, Props } from "./interfaces";
// components
import Accordeon, { AccordeonItem } from './content-styling/Accordeon';
import InfoImg from './content-styling/InfoImg';
import translit from './translit';
// analytics
import gtag from '../analytics/gtag.js';
// styles
import './Tabs.css';

// удалить компонент после того, как полностью уйдут табы в формате JSON
class Tabs extends React.Component<Props, {selectedTabIndex: number}> {
  private teamSuccessItems: Array<AccordeonItem>;
  private tabs: Array<{title: string, content: string | JSX.Element }> = this.props.tabs ? this.props.tabs.slice() : [];

  constructor(props: Props) {
    super(props);
    this.state = {
      selectedTabIndex: 0
    }
    this.onTabClick = this.onTabClick.bind(this);
    this.teamSuccessItems = [
      {
        title: "Дистанционное обучение",
        subtitle: "Запустили абсолютно новое направление на платформе за 4 недели. И ни одного критического бага!",
        content: (
          <InfoImg
            src="http://localhost:1337/uploads/image_6_2x_a18920d055.png"
            alt="Наш новый проект"
            blocks={[
              {title: "20 000 учеников", content: "занимаются дистанционно каждый день и не ходят в школу"},
              {title: "147 кошек", content: "пострадали из-за вечного карантина. И один попугайчик"},
            ]}
          />
        )
      },
      {
        title: "Обучение енотов охоте на синие фантики",
        subtitle: "Subtitle Обучение енотов охоте на синие фантики",
        content: "Lorem ipsum dolor sit amet"
      },
      {
        title: "Закачка знаний через спутник",
        subtitle: "Subtitle Закачка знаний через спутник",
        content: "Lorem ipsum dolor sit amet Закачка знаний через спутник"
      }
    ];

    if (this.props.hasTeamSuccessTab) {
      this.tabs.push({
        title: "Успехи команды",
        content: <Accordeon items={ this.teamSuccessItems }/>,
      });
    }
  }


  onTabClick(ev: MouseEvent): void {
    let newIndex: string | null | number = ev.currentTarget.getAttribute("data-index");
    if (newIndex) {
      newIndex = parseInt(newIndex, 10);
      this.setState({ ...this.state, selectedTabIndex: newIndex });

      const tabName = this.tabs[newIndex].title;

      gtag('event', 'click', {
        'event_category' : 'vacancy_tab',
        'event_label' : `vacancy_tab_${this.transliterate(tabName)}`
      });
    }

    if (this.props.onSwitch) this.props.onSwitch();
  }


  tabHeadView(title: string, tabIndex: number): ReactNode {
    const { selectedTabIndex } = this.state;
    const klass = {
      selected: selectedTabIndex === tabIndex,
      head: true
    }
    return (
      <div
        className={classNames(klass)}
        key={`tab-head-${tabIndex}`}
        onClick={this.onTabClick}
        data-index={tabIndex}>
        <div className="tab-head-inner">
          {title}
        </div>
      </div>
    );
  }

  tabBodyView(title: string, content: string | JSX.Element, tabIndex: number): JSX.Element {
    const sanitizer = dompurify.sanitize;
    const { selectedTabIndex } = this.state;
    const klass = {
      selected: selectedTabIndex === tabIndex,
      'tab-content': true,
      body: true,
    }

    if (typeof(content) === 'string') {
      content = (
        <div
          id={`tab-content-${tabIndex}` }
          className={classNames(klass)}
          key={`tab-body-${tabIndex}`}
          dangerouslySetInnerHTML={{__html: sanitizer(content) }}
        />
      )
    } else {
      content = (
        <div
          id={`tab-content-${tabIndex}` }
          className={classNames(klass)}
          key={`tab-body-${tabIndex}`}>
          { content }
        </div>
      )
    }

    return (
      <React.Fragment key={`tab-body-${tabIndex}`}>
        <h4  className="mobile-visible tab-title bold">{title}</h4>
        { content }
      </React.Fragment>
    );
  }

  tabHeads(items: Array<{title: string, content: string | JSX.Element }>): ReactNode {
    return (
      <>
        { items.map((t, i) => this.tabHeadView(t.title, i)) }
      </>
    );
  }

  tabBodies(items: Array<{title: string, content: string | JSX.Element }>): ReactNode {
    return (
      <>
        { items.map((t, i) => this.tabBodyView(t.title, t.content, i)) }
      </>
    );
  }

  private transliterate(word: string): string {
    const dict: {[key: string]: string} = translit;
    const delimeter = '';
    return word.toLowerCase().split(delimeter).map((char) => dict[char] || char).join(delimeter);
  }

  render(): JSX.Element | null {
    const { children } = this.props;
    if (!this.tabs || !this.tabs.length) return null;

    return (
      <div className="tabs">
        { children }
        <div className={ContainerClass.Heads}>
          { this.tabHeads(this.tabs) }
        </div>
        <div className={ContainerClass.Bodies}>
          { this.tabBodies(this.tabs) }
        </div>
      </div>
    );
  }
}

export default Tabs;
